import React from 'react';
import DynamicLegalPage from '../components/DynamicLegalPage';

const TermsPage: React.FC = () => {
  return <DynamicLegalPage pageType="terms" />;
};

export default TermsPage; 